import React from 'react';

// @ts-ignore
import Ui5MultiselectOptions from "../../../../core/gd-ui/multiselect-options/ui5-multiselect-options";
import FormError from "../../../gd-form/common/form-error/form-error";
import FormRow from "../../../gd-form/form/form-ui5/form-row";
import {CustomFieldScope} from "../../../gd/const/fields/custom-fields-v1-const";

type Props = {
    form            : any
    mandatoryScope  : CustomFieldScope[]
}

export default function CustomField_FromRowScope(props:Props) {

    const scopeOptions = [
        {value: gd.const.customFields.scope.TASK,       label: "Tasks"},
        {value: gd.const.customFields.scope.PROJECT,    label: "Folders"},
        // {value: gd.const.customFields.scope.USER,       label: "Users"}
    ];

    return (
        <FormRow label="Scope">
            <Ui5MultiselectOptions className="m-t-15"
                                   form={props.form}
                                   name="scope"
                                   typeFilterValues={scopeOptions}
                                   lockedValues={props.mandatoryScope}/>
            <FormError form={props.form} name="scope" />
        </FormRow>
    );
}
